import { getPeriodTypeFromId } from "../../period/PeriodType.js";
import WrapperFormulaNode from "./WrapperFormulaNode.js";

/**
 * Wraps another node to represent its value in the context of a
 * period type.
 *
 * @param {PeriodType} periodType - Which kind of period
 */
export default class PeriodChangeFormulaNode extends WrapperFormulaNode {
	constructor({ periodType }) {
		super(...arguments);
		this._periodType = periodType;
	}

	getPeriodType() {
		return this._periodType;
	}

	accept(visitor, additionalInformation) {
		return visitor.visitPeriodChangeFormulaNode(
			this,
			additionalInformation,
		);
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.periodType = this._periodType?.getId();

		return properties;
	}

	static getType() {
		return "PeriodChangeNode";
	}

	static transformMaterializationData(data) {
		super.transformMaterializationData(...arguments);
		data.periodType = getPeriodTypeFromId(data.periodType);
	}
}
